import React, { useMemo, useRef, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Form, Spinner } from 'react-bootstrap';
import _ from 'lodash';
import tinycolor from 'tinycolor2';
import { layoutDefaults } from '../../utils/layout-defaults';
import { LocationIcon } from './location-icon';
import { ShouldFadeIn } from '../should-fade-in';

// const iconMargin = 12;

function NewAddressListItem({
  place,
  index,
  onSelect,
  country,
  disabled = false,
}) {
  const [loading, setLoading] = useState(false);
  const classes = useStyles({
    index,
    disabled: disabled && !loading,
    nullPlace: place == null,
  });
  const radioRef = useRef();

  const handleOnClick = () => {
    // setSelected(!selected);

    if (radioRef.current == null) {
      onSelect?.call(this, null, setLoading);
    } else {
      radioRef.current?.click();
    }
  };

  const handleOnChange = (event) => {
    if (disabled) return;

    event.stopPropagation();
    const { checked } = event.target;

    if (checked) {
      // _.delay(() => {
      onSelect?.call(this, place, setLoading);
      // });
    }
  };

  const description = useMemo(() => {
    if (place == null) return null;

    let result = place?.structured_formatting.secondary_text;

    if (_.endsWith(result, country?.name)) {
      result = result.slice(0, result.lastIndexOf(country?.name));
      result = result.trim();
      result = result.replace(/\W+$/, '');
    }

    return result;
  }, [place, country]);

  return (
    <ShouldFadeIn index={index}>
      <div className={classes.container} onClick={handleOnClick} aria-hidden>
        {place != null && !loading && (
          <Form.Check
            ref={radioRef}
            type="radio"
            size="lg"
            name="place"
            disabled={disabled && !loading}
            className={classes.radio}
            readOnly={false}
            onChange={handleOnChange}
          />
        )}

        {place == null && !loading && (
          <div className={classes.icon}>
            <LocationIcon disabled={disabled && !loading} />
          </div>
        )}

        {loading && (
          <div>
            <Spinner className={classes.spinner} size="sm" />
          </div>
        )}

        <div className={classes.rightContainer}>
          {place != null && (
            <>
              <div className={classes.title}>
                {place.structured_formatting.main_text}
              </div>
              <div className={classes.description}>{description}</div>
            </>
          )}

          {place == null && (
            <>
              <div className={classes.title}>Use sua localização</div>

              {/* <div className={classes.description}>{description}</div> */}
            </>
          )}
        </div>
      </div>
    </ShouldFadeIn>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',

    backgroundColor: layoutDefaults.cardColor,
    borderRadius: layoutDefaults.radius,

    paddingTop: ({ index }) =>
      index != null
        ? layoutDefaults.verticalMargin
        : layoutDefaults.verticalMargin - 2,
    paddingBottom: ({ index }) =>
      index != null
        ? layoutDefaults.verticalMargin
        : layoutDefaults.verticalMargin - 2,
    marginBottom: layoutDefaults.smallerVerticalMargin,

    paddingRight: layoutDefaults.horizontalMargin,

    // border: '1px solid red',
  },
  radio: {
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    paddingLeft: layoutDefaults.horizontalMargin,
    paddingRight: layoutDefaults.horizontalMargin,
  },
  icon: {
    fontSize: layoutDefaults.bigFontSize,
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    paddingLeft: layoutDefaults.horizontalMargin + 1,
    paddingRight: layoutDefaults.horizontalMargin - 1,
  },
  rightContainer: {
    flex: 1,
    // border: '1px solid black',
  },
  title: {
    textTransform: ({ nullPlace }) => (nullPlace ? 'none' : 'uppercase'),
    fontSize: ({ nullPlace }) =>
      nullPlace ? layoutDefaults.fontSize : layoutDefaults.smallFontSize,
    // fontWeight: ({ nullPlace }) => (nullPlace ? 'normal' : 'bold'),
    textAlign: 'left',
    opacity: ({ disabled }) => (disabled ? layoutDefaults.opacity : 1),
    // fontWeight: 'bold',
    // border: '1px solid blue',
  },
  description: {
    fontSize: layoutDefaults.fontSize,
    paddingTop: layoutDefaults.smallestVerticalMargin,
    textAlign: 'left',
    opacity: ({ disabled }) =>
      disabled ? layoutDefaults.smallOpacity : layoutDefaults.opacity,
    // border: '1px solid yellow',
  },
  spinner: {
    fontSize: layoutDefaults.smallFontSize,
    marginTop: ({ nullPlace }) =>
      nullPlace ? null : layoutDefaults.smallVerticalMargin - 1,
    marginLeft:
      layoutDefaults.horizontalMargin + layoutDefaults.smallestHorizontalMargin,
    marginRight: layoutDefaults.horizontalMargin - 0.5,
    color: tinycolor(layoutDefaults.buttonBackgroundPrimary)
      .darken(20)
      .toHexString(),
  },
});

export { NewAddressListItem };
